import { render, staticRenderFns } from "./WrestlingCell.vue?vue&type=template&id=ae0d26c4&scoped=true"
import script from "./WrestlingCell.vue?vue&type=script&lang=js"
export * from "./WrestlingCell.vue?vue&type=script&lang=js"
import style0 from "./WrestlingCell.vue?vue&type=style&index=0&id=ae0d26c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0d26c4",
  null
  
)

export default component.exports